import Vue from "vue";
import Router from "vue-router";
import { authGuard } from "../auth/authGuard";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");
const ListPorts = () => import("@/views/ListPorts");
const PortDetails = () => import("@/views/PortDetails");
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");

Vue.use(Router);

const router = new Router({
  mode: "hash",
  //base: process.env.BASE_URL,
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "ports",
          name: "List Ports",
          component: ListPorts,

          children: [
            {
              path: ":port_id",
              name: "Port Details",
              component: PortDetails,
            },
          ],
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
      ],
    },
  ];
}

router.beforeEach(authGuard);

export default router;
